import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { IFutureOrder } from "../interface/ICart";
import { GetFutureOrderServiceParamModel } from "../model/cart";


import CartService from "../service/CartService";
import { RootState } from "../store/store";

import { logoutUser } from "./common";


const _service = new CartService();

export const resetFutureOrder = createAction("futureorder/reset")

type SliceState = { value: IFutureOrder, status: string,apiCallCount:number}

const initialState: SliceState = {
  value: {},
  status: COMMON_STATUS.INITIAL,
  apiCallCount:0
} as SliceState;


export const getFutureOrderAsync = createAsyncThunk(
  "futureorder/getCart",
  async (params: GetFutureOrderServiceParamModel) => {
    const response = await _service.getFutureOrderService(params);
    return response;
  }
);


export const futureOrderSlice = createSlice({
  name: "futureorder",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      //GET
      .addCase(getFutureOrderAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getFutureOrderAsync.fulfilled, (state, action) => {
        state.value = action.payload;
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(getFutureOrderAsync.rejected, (state) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetFutureOrder, () => {
        return initialState;
      });
  },
});

export const getFutureOrders = (state: RootState) => state.futureorder.value;
export const getFutureOrderStatus = (state: RootState) => state.futureorder.status;
export default futureOrderSlice.reducer;